import { Form, Spin } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Endpoints from "../../api/endpoints";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import PageRoutes from "../../utils/routes";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import ApplicationStatusForm from "./ApplicationStatusForm";
import routes from "../../utils/routes";

const CreateApplicationStatus = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const createApplicationStatus = async (values) => {
    console.log("---VALUES---", values);
    setIsLoading(true);

    const requestBody = {
      minVersion: values.minVersion,
      maxVersion: values.maxVersion,
      os: values.os,
      forceUpdate: values.forceUpdate,
      recommendUpdate: values.recommendUpdate,
      maintenanceMode: values.maintenanceMode,
      app: values.app,
    };
    console.log("---REQUEST BODY---", requestBody);

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.addApplicationStatus,
      axiosPrivate: axiosPrivate,
      requestBody: requestBody,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Başarılı", "Uygulama Durumu Oluşturuldu.", () => {
        closeModal();
        navigate(routes.applicationStatuses);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <div>
      <ApplicationStatusForm form={form} onFinish={createApplicationStatus} />

      <Spin spinning={isLoading} fullscreen />

      <ModalComponent></ModalComponent>
    </div>
  );
};

export default CreateApplicationStatus;
